import { render, staticRenderFns } from "./Reviewslist.vue?vue&type=template&id=811393d8&scoped=true"
import script from "./Reviewslist.vue?vue&type=script&lang=js"
export * from "./Reviewslist.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Reviewslist.vue?vue&type=style&index=1&id=811393d8&prod&lang=css"
import style2 from "./Reviewslist.vue?vue&type=style&index=2&id=811393d8&prod&scoped=true&lang=css"
import style3 from "./Reviewslist.vue?vue&type=style&index=3&id=811393d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811393d8",
  null
  
)

export default component.exports